import { render, staticRenderFns } from "./TabCheck.vue?vue&type=template&id=6b7548d6&"
import script from "./TabCheck.vue?vue&type=script&lang=js&"
export * from "./TabCheck.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports